"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const x5_gmaps_1 = require("x5-gmaps");
const vue_property_decorator_1 = require("vue-property-decorator");
let SucursalesMapa = class SucursalesMapa extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.markers = [];
        this.miUbicacion = null;
        this.options = {
            zoom: this.zoom,
            center: { lat: this.centerLat, lng: this.centerLng },
            zoomControl: true,
            scaleControl: false,
            mapTypeControl: false,
            backgroundColor: "#aadaff",
            fullscreenControl: false,
            streetViewControl: false,
        };
        this.markerIcon = "https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi.png";
    }
    mounted() {
        let markers = [];
        this.sucursales.forEach((sucursal) => {
            markers.push({
                icon: this.markerIcon,
                title: sucursal.nombre,
                position: {
                    lat: sucursal.coordenadas.lat,
                    lng: sucursal.coordenadas.lng,
                },
            });
        });
        this.$GMaps().then((GMaps) => {
            markers.forEach((marker) => {
                marker.animation = GMaps.Animation.DROP;
            });
        });
        this.markers = markers;
        if (this.markers.length > 1) {
            this.fitBounds();
        }
    }
    get total() {
        return this.sucursales.length;
    }
    fitBounds() {
        this.$GMaps().then((GMaps) => {
            let bounds = new GMaps.LatLngBounds();
            this.markers.forEach((marker) => {
                bounds.extend(marker.position);
            });
            if (this.miUbicacion) {
                bounds.extend(this.miUbicacion);
            }
            this.$refs.mapa.map.fitBounds(bounds);
        });
    }
    getLocation() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(this.setLocation, this.locationError);
        }
        else {
            alert("Geolocation no soportada por el navegador.");
        }
    }
    setLocation(pos) {
        this.options = Object.assign(Object.assign({}, this.options), { center: { lat: pos.coords.latitude, lng: pos.coords.longitude } });
        this.miUbicacion = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        this.fitBounds();
    }
    locationError(error) {
        if (error.PERMISSION_DENIED)
            alert("User denied the request for Geolocation.");
        else if (error.POSITION_UNAVAILABLE)
            alert("Location information is unavailable.");
        else if (error.TIMEOUT)
            alert("The request to get user location timed out.");
        else
            alert("An unknown error occurred.");
    }
};
__decorate([
    vue_property_decorator_1.Prop({ type: Array, required: true }),
    __metadata("design:type", Array)
], SucursalesMapa.prototype, "sucursales", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Number, required: true }),
    __metadata("design:type", Number)
], SucursalesMapa.prototype, "centerLat", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Number, required: true }),
    __metadata("design:type", Number)
], SucursalesMapa.prototype, "centerLng", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Number, required: false, default: 10 }),
    __metadata("design:type", Number)
], SucursalesMapa.prototype, "zoom", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Number, required: false, default: 650 }),
    __metadata("design:type", Number)
], SucursalesMapa.prototype, "height", void 0);
SucursalesMapa = __decorate([
    vue_property_decorator_1.Component({ components: { gmapsMap: x5_gmaps_1.gmapsMap, gmapsMarker: x5_gmaps_1.gmapsMarker } })
], SucursalesMapa);
exports.default = SucursalesMapa;
